import { DialogType } from '../../@types';
import { BettingActivity, WalletType } from '../../@types/api';
import { BETTING_ACTIVITY_OPTIONS, SPORTSBOOK_FROM_OPTIONS, SPORTSBOOK_WALLET_TYPE } from '../../constants';
import { BETTING_ACTIVITY, WALLET_TYPE } from '../../constants/enums';
import useFilterForm from '../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../hooks/usePagination';
import FilterDialogLayout from '../layouts/FilterDialogLayout';
import FormSelect from '../molecules/FormSelect';

type FilterManagersReportData = {
  from?: string;
  walletType?: WalletType;
  bettingActivity?: BettingActivity;
};

const defaultValues = {
  from: undefined,
  walletType: WALLET_TYPE.MAIN,
  bettingActivity: BETTING_ACTIVITY.ACTIVE,
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterManagersReport = ({ changeQuery, closeModal }: Props) => {
  const { control, handleSubmit, handleResetFilter } = useFilterForm<FilterManagersReportData>({
    defaultData: defaultValues,
    changeQuery,
  });

  const handleClose = () => {
    closeModal?.();
  };

  return (
    <FilterDialogLayout label='reports' onSave={handleSubmit} onClose={handleClose} onReset={handleResetFilter}>
      <FormSelect name='from' control={control} label='From' options={SPORTSBOOK_FROM_OPTIONS} />
      <FormSelect name='walletType' control={control} label='Bets' options={SPORTSBOOK_WALLET_TYPE} />
      <FormSelect
        name='bettingActivity'
        control={control}
        label='Betting Activity'
        options={BETTING_ACTIVITY_OPTIONS}
      />
    </FilterDialogLayout>
  );
};

export default FilterManagersReport;
